import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";

const API_BASE = getApiBaseUrl();

export interface DailyRecord {
  id?: number;
  date: string;       // YYYY-MM-DD
  mind: number;       // 1-5
  technique: number;  // 1-5
  body: number;       // 1-5
  diary: string;
  memo: string;
}

/**
 * 指定した期間の日々の記録を取得する
 * @param token 認証トークン
 * @param startDate 取得開始日 (YYYY-MM-DD)
 * @param endDate 取得終了日 (YYYY-MM-DD)
 */
export async function getDailyRecords(
  token: string, 
  startDate: string, 
  endDate: string
): Promise<{ records: DailyRecord[] }> {
  // GETリクエストの場合はクエリパラメータとして期間を渡す
  const query = new URLSearchParams({ startDate, endDate }).toString();
  
  return await apiFetch(`${API_BASE}/api/management/daily-records?${query}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * 日々の記録を保存（または更新）する
 * @param token 認証トークン
 * @param record 保存する記録データ
 */
export async function saveDailyRecord(
  token: string, 
  record: DailyRecord
): Promise<{ success: boolean; data: DailyRecord }> {
  return await apiFetch(`${API_BASE}/api/management/daily-records`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(record),
  });
}

/**
 * 日々の記録を削除する
 * @param token 認証トークン
 * @param id 削除対象のレコードID
 */
export async function deleteDailyRecord(
  token: string, 
  id: number
): Promise<{ success: boolean; message: string }> {
  return await apiFetch(`${API_BASE}/api/management/daily-records/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}